<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{ 'Notifications'|translate }}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs1>
                        <value-box
                            :value="this.$store.getters.notificationCount"
                            icon=""
                            use-int
                            :title="'Total'|translate">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                            :value="this.$store.getters.recentNotificationsCount"
                            icon=""
                            use-int
                            :title="'Unack'|translate">
                        </value-box>
                    </v-flex>

                    <v-flex xs1>
                        <value-box
                            :value="this.$store.getters.lowSeverityNotificationsCount"
                            icon=""
                            use-int
                            :title="'Low'|translate">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                            :value="this.$store.getters.mediumSeverityNotificationsCount"
                            icon=""
                            use-int
                            :title="'Medium'|translate">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                            :value="this.$store.getters.highSeverityNotificationsCount"
                            icon=""
                            use-int
                            :title="'High'|translate">
                        </value-box>
                    </v-flex>
                    <v-flex xs1>
                        <value-box
                            :value="this.$store.getters.criticalSeverityNotificationsCount"
                            icon=""
                            use-int
                            :title="'Critical'|translate">
                        </value-box>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2>
                        <v-switch color="success" class="ml-4" v-model="showRecent"
                                  :label="'Show Unack Notifications Only'|translate"></v-switch>
                    </v-flex>
                    <v-flex xs2 class="pt-3">
                        <v-btn-toggle v-model="toggle_exclusive">
                            <v-btn flat @click="rangeDays=30">
                                {{ '30 days'|translate }}
                            </v-btn>
                            <v-btn flat @click="rangeDays=90">
                                {{ '90 days'|translate }}
                            </v-btn>
                            <v-btn flat @click="rangeDays=365">
                                {{ '1 year'|translate }}
                            </v-btn>
                            <v-btn flat @click="rangeDays=null">
                                {{ 'all'|translate }}
                            </v-btn>
                        </v-btn-toggle>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field class="mr-4" clearable v-model="search" type="text"
                                      :label="'Keyword filter'|translate"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-tabs fixed-tabs v-model="tab" class="mt-4">
                    <v-tab :key="1">

                        <v-chip color="orange" text-color="white">
                            <v-avatar class="orange darken-4">{{ items1.length }}</v-avatar>
                            {{ 'Critical/High/Medium'|translate }}
                        </v-chip>

                    </v-tab>
                    <v-tab :key="2">
                        <v-chip color="blue" text-color="white">
                            <v-avatar class="blue darken-4">{{ items2.length }}</v-avatar>
                            {{ 'Low'|translate }}
                        </v-chip>
                    </v-tab>
                    <v-tab :key="3" v-if="items3&&items3.length>0">
                        <v-chip color="green" text-color="white">
                            <v-avatar class="green darken-4">{{ items3.length }}</v-avatar>
                            {{ 'Anomaly'|translate }}
                        </v-chip>
                    </v-tab>


                    <v-tab-item :key="1">
                        <v-layout row>
                            <v-spacer>
                            </v-spacer>
                            <v-btn class="accent" @click="exportNotification(items1)">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download'|translate }}
                            </v-btn>
                            <v-btn class="accent" @click="exportNotifWithMR(items1)">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download with Maintenance'|translate }}
                            </v-btn>
                        </v-layout>


                        <v-data-table
                            :headers="headers"
                            disable-initial-sort
                            :items="items1"
                            :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        >
                            <template v-slot:items="props">
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.notification_id }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.title }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.equip }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.equipType }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.topic }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.floor }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer caption">
                                    {{ props.item.description }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.startDate }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.endDate }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                fa-bell
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                fa-bell-slash
                                            </v-icon>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <template v-slot:badge
                                                          v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                    <span>{{ props.item.maintenance_records.length }}</span>
                                                </template>
                                                <v-icon v-on="on" small class="ml-2 mr-1"
                                                        @click="callDialog(props.item)">fa-clipboard-list
                                                </v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ props.item.maintenance_records.length }} {{ 'Maintenance Records'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ 'Maintenance Completed'|translate }} </span>
                                    </v-tooltip>
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="i in Array.from(new Set(props.item.maintenance_records.filter(x=>!x.is_fixed&&x.assigned_to&&x.assigned_to!=='').map(x=>x.assigned_to)))">{{ i }}</li>
                                    </ul>
                                </td>
                                <td class="text-xs-left" style="min-width: 120px;">
                                    <v-icon small class="mr-2" @click="callDialog(props.item)">
                                        fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="callMaintenanceDialog(props.item)"
                                            >
                                                fa-notes-medical
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Add maintenance record'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View chart'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    @click="jumpToMR(props.item)"
                                            >
                                                fa-clipboard-list
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View maintenanace records for this period'|translate }} </span>
                                    </v-tooltip>


                                </td>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item :key="2">
                        <v-layout row>
                            <v-spacer>
                            </v-spacer>
                            <v-btn class="accent" @click="exportNotification(items2)">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download'|translate }}
                            </v-btn>
                            <v-btn class="accent" @click="exportNotifWithMR(items2)">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download with Maintenance'|translate }}
                            </v-btn>
                        </v-layout>
                        <v-data-table
                            :headers="headers"
                            disable-initial-sort
                            :items="items2"
                            :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        >
                            <template v-slot:items="props">
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.notification_id }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.title }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.equip }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.equipType }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.topic }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.floor }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer caption">
                                    {{ props.item.description }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.startDate }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.endDate }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                fa-bell
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                fa-bell-slash
                                            </v-icon>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <template v-slot:badge
                                                          v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                    <span>{{ props.item.maintenance_records.length }}</span>
                                                </template>
                                                <v-icon v-on="on" small class="ml-2 mr-1"
                                                        @click="callDialog(props.item)">fa-clipboard-list
                                                </v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ props.item.maintenance_records.length }} {{ 'Maintenance Records'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ 'Maintenance Completed'|translate }} </span>
                                    </v-tooltip>
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="i in Array.from(new Set(props.item.maintenance_records.filter(x=>!x.is_fixed&&x.assigned_to&&x.assigned_to!=='').map(x=>x.assigned_to)))">{{ i }}</li>
                                    </ul>
                                </td>
                                <td class="text-xs-left" style="min-width: 120px;">
                                    <v-icon small class="mr-2" @click="callDialog(props.item)">
                                        fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="callMaintenanceDialog(props.item)"
                                            >
                                                fa-notes-medical
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Add maintenance record'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View chart'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    @click="jumpToMR(props.item)"
                                            >
                                                fa-clipboard-list
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View maintenanace records for this period'|translate }} </span>
                                    </v-tooltip>


                                </td>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item :key="3" v-if="items3&&items3.length>0">
                        <v-layout row>
                            <v-spacer>
                            </v-spacer>
                            <v-btn class="accent" @click="exportNotification(items3)">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download'|translate }}
                            </v-btn>
                            <v-btn class="accent" @click="exportNotifWithMR(items3)">
                                <v-icon small class="mr-2">fa-download</v-icon>
                                {{ 'Download with Maintenance'|translate }}
                            </v-btn>
                        </v-layout>
                        <v-data-table
                            :headers="headers"
                            disable-initial-sort
                            :items="items3"
                            :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        >
                            <template v-slot:items="props">
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.notification_id }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.title }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.equip }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.equipType }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.topic }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.floor }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer caption">
                                    {{ props.item.description }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.startDate }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    {{ props.item.endDate }}
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                fa-bell
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                fa-bell-slash
                                            </v-icon>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <template v-slot:badge
                                                          v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                    <span>{{ props.item.maintenance_records.length }}</span>
                                                </template>
                                                <v-icon v-on="on" small class="ml-2 mr-1"
                                                        @click="callDialog(props.item)">fa-clipboard-list
                                                </v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ props.item.maintenance_records.length }} {{ 'Maintenance Records'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ 'Maintenance Completed'|translate }} </span>
                                    </v-tooltip>
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="i in Array.from(new Set(props.item.maintenance_records.filter(x=>!x.is_fixed&&x.assigned_to&&x.assigned_to!=='').map(x=>x.assigned_to)))">{{ i }}</li>
                                    </ul>
                                </td>
                                <td class="text-xs-left" style="min-width: 120px;">
                                    <v-icon small class="mr-2" @click="callDialog(props.item)">
                                        fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="callMaintenanceDialog(props.item)"
                                            >
                                                fa-notes-medical
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Add maintenance record'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View chart'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    @click="jumpToMR(props.item)"
                                            >
                                                fa-clipboard-list
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View maintenanace records for this period'|translate }} </span>
                                    </v-tooltip>


                                </td>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs>
                <v-layout row wrap>
                    <v-flex xs12 class="pa-4">
                        <v-dialog v-model="dialog" :max-width="showAllMRForEquipment ? null : 1200">
                            <v-card>
                                <v-card-title class="primary white--text title">
                                    {{ currentItem.title }}
                                </v-card-title>
                                <v-card-text>
                                    <p class="headline">
                                        {{ 'Equipment'|translate }} : {{ currentItem.equip }}
                                    </p>
                                    <p>
                                        {{ currentItem.description }}
                                    </p>
                                    <p>
                                        {{ 'Occured between'|translate }} {{ currentItem.startDate.replace('T', ' ') }}
                                        {{ 'and'|translate }}
                                        {{ currentItem.endDate.replace('T', ' ') }}
                                    </p>
                                </v-card-text>
                                <v-divider v-if="currentItem.recommendedActions"></v-divider>
                                <v-card-text v-if="currentItem.recommendedActions">
                                    <p class="headline">
                                        <v-icon>fa-shoe-prints</v-icon>
                                        {{ 'Recommended Actions'|translate }}
                                    </p>
                                    <ul v-if="currentItem.recommendedActions">
                                        <li v-for="i in currentItem.recommendedActions.split('\n')">
                                            {{ i }}
                                        </li>
                                    </ul>
                                </v-card-text>
                                <v-divider
                                    v-if="currentItem.maintenance_records&&currentItem.maintenance_records.length>0"></v-divider>
                                <v-card-text
                                    v-if="currentItem.maintenance_records&&currentItem.maintenance_records.length>0">
                                    <p class="headline">
                                        <v-icon>fa-clipboard-list</v-icon>
                                        {{ 'Maintenance Records'|translate }}
                                    </p>
                                    <v-data-table
                                        :headers="maintenanaceHeaders"
                                        :items="currentItem.maintenance_records"
                                        class="elevation-1"
                                    >
                                        <template v-slot:items="props">
                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                {{ props.item.maintenance_id }}
                                            </td>
                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                {{ props.item.maintenance_label }}
                                            </td>
                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                <v-icon v-if="props.item.is_fixed" color="success">fa-check</v-icon>
                                                <v-icon v-else color="warning">fa-times</v-icon>
                                            </td>

                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                {{ props.item.assigned_to }}
                                            </td>
                                            <td class="cursor-as-pointer text-xs-left">{{ props.item.assigned_by }}</td>
                                            <td class="cursor-as-pointer text-xs-left">
                                                <span v-if="props.item.assigned_date&&props.item.assigned_date!=='NaT'">{{
                                                        props.item.assigned_date.substring(0, 10)
                                                    }}</span>
                                            </td>

                                        </template>
                                        <template v-slot:no-data>
                                            <v-btn color="primary" @click="initialize">{{ 'Refresh'|translate }}</v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                                <v-card-text v-if="showAllMRForEquipment">
                                    <p class="headline">
                                        <v-icon>fa-clipboard-list</v-icon>
                                        {{ 'All Maintenance Records for '|translate }} {{ currentItem.equip }}
                                    </p>
                                    <maintenance-record :equipment-filter="currentItem.equip" ></maintenance-record>
                                </v-card-text>
                                <v-card-actions>
                                    <v-switch color="success" v-model="showAllMRForEquipment" class="pa-0 ma-0 pt-3 pl-2"
                                              :label="'Show All Maintenance Records'|translate"></v-switch>
                                    <v-spacer></v-spacer>
                                    <v-btn icon v-if="!currentItem.acknowledged"
                                           @click="trigger(currentItem.notification_id, currentItem.acknowledged);currentItem.acknowledged=true;">
                                        <v-icon color="warning">fa-bell</v-icon>
                                    </v-btn>
                                    <v-btn icon v-if="currentItem.acknowledged"
                                           @click="trigger(currentItem.notification_id, currentItem.acknowledged);currentItem.acknowledged=false;">
                                        <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                    </v-btn>
                                    <v-btn class="primary" round @click="callMaintenanceDialog(currentItem)">
                                        <v-icon class="mr-2">fa-notes-medical</v-icon>
                                        {{ 'Add Maintenance Record'|translate }}
                                    </v-btn>
                                    <v-btn class="accent" round @click="jumpToLink(currentItem)">
                                        <v-icon class="mr-2">fa-chart-line</v-icon>
                                        {{ 'View Chart'|translate }}
                                    </v-btn>
                                    <v-btn class="accent" round @click="jumpToLinkNW(currentItem)">
                                        <v-icon class="mr-2">fa-chart-line</v-icon>
                                        {{ 'View Chart in New Tab'|translate }}
                                    </v-btn>
                                    <v-btn class="accent" round @click="dialog = false">
                                        {{ 'Cancel'|translate }}
                                    </v-btn>
                                </v-card-actions>
                                <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"
                                                     v-on:doreload="refresh()"></fault-record-dialog>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getNotification} from '@/helper'
import FaultRecordDialog from '../components/FaultRecordDialog'
import SeverityChip from '../components/SeverityChip'
import {putNotification, getMaintenanceRecords} from '../helper'
import {exportCSV} from '../tocsv'
import ValueBox from "../components/ValueBox";
import _ from 'lodash'
import moment from 'moment'
import MaintenanceRecord from "./MaintenanceRecord.vue";

export default {
    name: 'Notifications2',
    components: {SeverityChip, FaultRecordDialog, ValueBox,MaintenanceRecord},
    data() {
        return {
            activeFacets: {},
            facetOptions: {},
            toggle_exclusive: 1,
            dialog: false,
            rangeDays: 90,
            maxDate: moment(),
            showRecent: true,
            showAllMRForEquipment: false,
            tab: 0,
            items: null,
            search: '',
            search2: '',
            maintenanceDialog: false,
            maintenanceItem: null,
            maintenanaceHeaders: [
                {
                    text: this.$options.filters.translate('ID'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_id'
                },
                {
                    text: this.$options.filters.translate('Fault'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_label'
                },
                {text: this.$options.filters.translate('Fixed'), value: 'is_fixed'},
                {text: this.$options.filters.translate('Assigned to'), value: 'assigned_to'},
                {text: this.$options.filters.translate('Assigned by'), value: 'assigned_by'},
                {text: this.$options.filters.translate('Assigned date'), value: 'assigned_date'},
            ],
            facets: {
                "floor": this.$options.filters.translate("Floor"),
                "equipment_name": this.$options.filters.translate("Equipment"),
                "severity": this.$options.filters.translate("Severity"),
                "equipment_type": this.$options.filters.translate("Equipment Type"),
                "title": this.$options.filters.translate("Issue"),
                "topic": this.$options.filters.translate("Topic"),
            },
            currentItem: {
                icon: 'fa-bell',
                title: 'Condenser Cleaning Required in Chiller 1',
                equip: 'Chiller 1',
                startDate: '',
                endDate: '',
                to: {
                    path: '/sensors',
                    query: {
                        onOnly: true,
                        variableX: 'Cond_Approach',
                        variableY: 'Cond_Approach',
                        rangeStart: '2018-01-01',
                        rangeEnd: '2018-06-30',
                        equipment: 'Chiller 1'
                    }
                },
                description: "Condenser Approach High in Chiller 1",
                recommendedActions: [
                    'Clean Condenser Tubes',
                    'Check Condenser Water Pumps',
                ].join('\n')
            },
            facetGraphs: [],
            loading: true,
            rawNotifs: null,
            rawMRs: null,
            notifs: null,
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        },
        showRecent(newValue) {
            this.getData(newValue)
        },
        rangeDays() {
            this.getData(this.showRecent)
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$options.filters.translate('ID'),
                    align: 'left',
                    sortable: true,
                    value: 'notification_id'
                }, {
                    text: this.$options.filters.translate('Alerts'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {text: this.$options.filters.translate('Equipment'), value: 'equip'},
                {text: this.$options.filters.translate('Equipment Type'), value: 'equipType', sortable: true},
                {text: this.$options.filters.translate('Topic'), value: 'topic', sortable: true},
                {text: this.$options.filters.translate('Floor'), value: 'floor', sortable: true},
                {text: this.$options.filters.translate('Description'), value: 'description'},
                {text: this.$options.filters.translate('Start Date'), value: 'startDate'},
                {text: this.$options.filters.translate('End Date'), value: 'endDate'},
                {text: this.$options.filters.translate('Severity'), value: 'severity'},
                {text: this.$options.filters.translate('Acknowledged'), value: 'acknowledged'},
                {text: this.$options.filters.translate('Assigned to'), value: 'acknowledged'},
                {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false}
            ]
        },
        items1() {
            if (!this.items) {
                return []
            }
            let filtered = this.items.filter(x => !(x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")) && (x.severity.toLowerCase() === "critical" || x.severity.toLowerCase() === "high" || x.severity.toLowerCase() === "medium"))
            if (this.showRecent) {
                filtered = filtered.filter(x => !x.acknowledged)
            }
            if (this.search2 && this.search2 !== "") {
                filtered = filtered.filter(x => this.filterItemProperly(x))
            }
            return filtered
        },
        items2() {
            if (!this.items) {
                return []
            }
            let filtered = this.items.filter(x => !(x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")) && (x.severity.toLowerCase() === "low"))
            if (this.showRecent) {
                filtered = filtered.filter(x => !x.acknowledged)
            }
            if (this.search2 && this.search2 !== "") {
                filtered = filtered.filter(x => this.filterItemProperly(x))
            }
            return filtered
        },
        items3() {
            if (!this.items) {
                return []
            }
            let filtered = this.items.filter(x => (x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")))
            if (this.showRecent) {
                filtered = filtered.filter(x => !x.acknowledged)
            }
            if (this.search2 && this.search2 !== "") {
                filtered = filtered.filter(x => this.filterItemProperly(x))
            }
            return filtered
        },
    },
    methods: {
        filterItemProperly(item){
            if (item.maintenance_records){
                let {maintenance_records, ...itemWithoutMR} = item;
                return JSON.stringify(Object.values(itemWithoutMR)).toLowerCase().indexOf(this.search2.toLowerCase()) > -1
            } else {
                return JSON.stringify(Object.values(item)).toLowerCase().indexOf(this.search2.toLowerCase()) > -1
            }
        },
        refresh() {
            this.maintenanceDialog = false
            this.maintenanceItem = null
            this.dialog = false
            this.getData(this.showRecent)
        },
        editMR(item) {
            this.maintenanceItem = JSON.parse(JSON.stringify(item))
            this.maintenanceDialog = true
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        jumpToLinkNW(item) {
            let output = this.getItemUrl(item)
            if (process.env.VUE_APP_SINGLE_WINDOW_MODE) {
                this.$router.push(output)
            } else {
                if (item.to && item.to.external_domain) {
                    window.open(item.to.external_domain + this.$router.resolve(output).href)
                } else {
                    window.open(this.$router.resolve(output).href)
                }
            }
        },
        async trigger(id, state) {
            await putNotification(
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'notification_id': id,
                    'show_flag': state
                }
            )
        },
        exportNotification(items) {
            let exportables=[]
            let cleanedItems = JSON.parse(JSON.stringify(items))
            for (let item of cleanedItems) {
                item.url = item.to && item.to.external_domain ? item.to.external_domain + this.$router.resolve(this.getItemUrl(item)).href : window.location.origin + this.$router.resolve(this.getItemUrl(item)).href
                delete (item.to)
                delete (item.icon)
                delete (item.maintenance_records)
                let newitem={
                    ID: item.notification_id,
                    Alerts: item.title,
                    Equipment: item.equip,
                    "Equipment Type": item.equipType,
                    Topic: item.topic,
                    Floor: item.floor,
                    Description: item.description,
                    "Start Date": item.startDate,
                    "End Date": item.endDate,
                    Severity: item.severity,
                    Acknowledged:item.acknowledged ? "Yes" : "No",
                    URL: item.url,
                    "Alert Type": item.alertType,
                    "Recommended Actions": item.recommendedActions,
                }
                if (!newitem["Recommended Actions"]) {
                    delete (newitem["Recommended Actions"])
                }
                exportables.push(newitem)
            }
            exportCSV(exportables)
        },
        exportNotifWithMR(items) {
            let cleanedItems = JSON.parse(JSON.stringify(items))
            let newItems = []
            let filledKeys = ["alertType", "title", "equip", "equipType", "floor", "startDate", "endDate", "topic", "occurredTimes", "description", "recommendedActions", "severity", "notification_id", "acknowledged", "url", "maintenance_id", "maintenance_text", "maintenance_label", "maintenance_date_from", "maintenance_date_to", "is_fixed", "fixed_by", "fixed_date", "assigned_by", "assigned_to", "assigned_date", "updated_on", "created_on", "equipment"]
            for (let item of cleanedItems) {
                item.url = item.to && item.to.external_domain ? item.to.external_domain + this.$router.resolve(this.getItemUrl(item)).href : window.location.origin + this.$router.resolve(this.getItemUrl(item)).href
                delete (item.to)
                delete (item.icon)
                let newitem={
                    ID: item.notification_id,
                    Alerts: item.title,
                    Equipment: item.equip,
                    "Equipment Type": item.equipType,
                    Topic: item.topic,
                    Floor: item.floor,
                    Description: item.description,
                    "Start Date": item.startDate,
                    "End Date": item.endDate,
                    Severity: item.severity,
                    Acknowledged:item.acknowledged ? "Yes" : "No",
                    URL: item.url,
                    "Alert Type": item.alertType,
                    "Recommended Actions": item.recommendedActions,
                }
                if (!newitem["Recommended Actions"]) {
                    delete (newitem["Recommended Actions"])
                }
                if (!item.maintenance_records || item.maintenance_records.length === 0) {
                    for (let key of filledKeys) {
                        if (typeof (newitem[key]) === "undefined") {
                            newitem[key] = ""
                        } else {
                            newitem[key] = newitem[key]
                        }
                    }
                    newItems.push(newitem)
                } else {
                    for (let mr of item.maintenance_records) {
                        let itemBase = JSON.parse(JSON.stringify(newitem))
                        itemBase = Object.assign(itemBase, mr)
                        delete (itemBase.equipment_name)
                        delete (itemBase.equipment_id)
                        delete (itemBase.equipment)
                        delete (itemBase.exclude_in_model)
                        delete (itemBase.comments)
                        newItems.push(itemBase)
                    }
                }

            }
            exportCSV(newItems)
        },
        getMaintenanceItem(item) {
            let itemUrlObj = this.getItemUrl(item)
            return {
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment: item['equip'],
                maintenance_date_from: item['startDate'],
                maintenance_date_to: item['endDate'],
                severity: item['severity'],
                maintenance_text: this.$options.filters.translate('Recommended Actions:') + ' \n\n' + item['recommendedActions'],
                maintenance_label: item['title'],
                url: this.$router.resolve(itemUrlObj).href,
                notification_id: item['notification_id'],
                is_fixed: false,
                maintenance_id: null
            }
        },
        callMaintenanceDialog(item, dialogOpen = true) {
            this.maintenanceItem = this.getMaintenanceItem(item)
            this.maintenanceDialog = dialogOpen
        },
        callDialog(item) {
            this.dialog = true
            this.currentItem = item
        },
        getItemUrl(item) {
            let output = null;
            if (item.title.substring(0, 7) === "Anomaly") {
                output = {
                    path: '/modelsummary',
                    query: {
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipment: item.equip
                    }
                }
            } else if (item.topic === "equipment health") {
                output = {
                    path: '/equipment-health',
                    query: {
                        equipment: item.equip,
                    }
                }
            } else {
                output = {
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: item.to.query.variableX,
                        faultName: item.title,
                        faultDesc: item.description,
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipmentName: item.equip,
                        nId: item.notification_id,
                        nTopic: item.topic,
                        nOct: item.occurredTimes
                    }
                }
            }
            return output
        },
        jumpToLink(item) {
            let output = this.getItemUrl(item)
            if (item.to && item.to.external_domain) {
                window.open(item.to.external_domain + this.$router.resolve(output).href)
            } else {
                this.$router.push(output)
            }
            // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
            // this.$router.push(item.to)
        },
        jumpToMR(item) {
            let output = {
                path: "/maintenancerecord",
                query: {
                    rangeStart: item.to.query.rangeStart,
                    rangeEnd: item.to.query.rangeEnd,
                }
            }
            if (item.to && item.to.external_domain) {
                window.open(item.to.external_domain + this.$router.resolve(output).href)
            } else {
                this.$router.push(output)
            }

        },

        getData(ignore_acknowledged) {
            let me = this;
            me.loading = true
            let range = null
            if (me.rangeDays) {
                range = [moment(me.maxDate).subtract(me.rangeDays, "days").format('YYYY-MM-DD'), moment(me.maxDate).format('YYYY-MM-DD') + " 23:59:59"]
            }
            let promises = [getNotification({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                ignore_acknowledged: ignore_acknowledged,
                date_range: range,
            }), getMaintenanceRecords({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                date_range: range ? {start: range[0], end: range[1]} : null
            })]
            Promise.all(promises).then(function (responses) {
                me.rawNotifs = responses[0].result
                me.rawMRs = responses[1].result
                me.refineNotifs()
            })

        },
        refineNotifs() {
            let me = this
            let notifs = me.rawNotifs
            let items = []
            for (let i in notifs) {
                let notification_id = notifs[i]['notification_id']
                items.push({
                    icon: 'fa-bell',
                    alertType: notifs[i]['model'],
                    title: notifs[i]['title'],
                    equip: notifs[i]['equipment_name'],
                    equipType: notifs[i]['equipment_type'],
                    floor: notifs[i]['floor'],
                    startDate: notifs[i]['start_date'],
                    endDate: notifs[i]['end_date'],
                    topic: notifs[i]['topic'],
                    occurredTimes: notifs[i]['occurred_times'],
                    to: notifs[i]['to'],
                    description: notifs[i]['description'],
                    recommendedActions: notifs[i]['recommended_actions'],
                    severity: notifs[i]['severity'],
                    notification_id: notification_id,
                    acknowledged: notifs[i]['acknowledged'],
                    maintenance_records: me.rawMRs.filter(x => x.notification_id && x.notification_id === notification_id)
                })
            }
            me.items = items = _.sortBy(items, ['startDate']).reverse()
            me.loading = false
            let id = _.get(this.$route.query, 'id', null)
            if (id) {
                let found = me.items.filter(x => x.notification_id && x.notification_id == id)
                if (found && found.length > 0) {
                    me.callDialog(found[0])
                    me.$router.replace({
                        path: me.$router.currentRoute.path,
                        query: {}
                    }).catch(err => {
                    })
                }
            }
        }
    },
    beforeMount() {
        let id = _.get(this.$route.query, 'id', null)
        if (id) {
            this.rangeDays = null
        }
    },
    mounted() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        if (maxDate) {
            this.maxDate = moment(maxDate)
        }
        this.getData(true);
    },


}
</script>
